import { imageUrl } from '../lib/images'

export default function DinBilpartnerBadge({ className = '' }) {
  return (
    <section className={`py-12 bg-gray-50 border-y border-gray-200 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="bg-white border border-gray-200 shadow-sm p-6 sm:p-8 lg:p-10 flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="flex-1 space-y-4">
            <div className="inline-block px-3 py-1 bg-red-50 border border-red-200 text-[#e20019] text-xs font-bold uppercase tracking-[0.2em]">
              <i className="fa-solid fa-certificate mr-1.5" aria-hidden="true" />
              <span>Kvalitetsstempel &amp; Tryghed</span>
            </div>

            <h3 className="font-display text-3xl sm:text-4xl font-bold uppercase text-gray-900 tracking-wide">
              En del af Din Bilpartner
            </h3>

            <p className="text-gray-600 text-sm sm:text-base leading-relaxed max-w-3xl">
              Siden januar 2023 har EK Biler været en del af Din Bilpartner. Det betyder, at vi
              arbejder ud fra konceptets principper om kompetent vejledning og ordentligt håndværk,
              samtidig med at du får den personlige kontakt, der følger med et lokalt værksted.
            </p>

            {/* Bullets directly from scrape */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-2">
              <div className="flex items-center gap-2.5 text-sm text-gray-700">
                <i className="fa-solid fa-circle-check text-[#e20019]" aria-hidden="true" />
                <span>Professionel service og reparation af alle bilmærker</span>
              </div>
              <div className="flex items-center gap-2.5 text-sm text-gray-700">
                <i className="fa-solid fa-circle-check text-[#e20019]" aria-hidden="true" />
                <span>Speciale i V.A.G Gruppen (VW – Audi – Seat – Skoda)</span>
              </div>
              <div className="flex items-center gap-2.5 text-sm text-gray-700">
                <i className="fa-solid fa-circle-check text-[#e20019]" aria-hidden="true" />
                <span>Altid mulighed for gratis lånebil</span>
              </div>
              <div className="flex items-center gap-2.5 text-sm text-gray-700">
                <i className="fa-solid fa-circle-check text-[#e20019]" aria-hidden="true" />
                <span>Express fordelskoncept &amp; bevaret fabriksgaranti</span>
              </div>
            </div>
          </div>

          {/* Logo & Seal */}
          <div className="shrink-0 flex flex-col items-center justify-center p-6 bg-gray-50 border border-gray-200 text-center w-full sm:w-auto">
            <img
              src={imageUrl('din-bil-partner-logo.jpg', 'width=360,quality=90,format=auto')}
              alt="Din Bilpartner medlemslogo"
              className="h-12 w-auto object-contain mb-3"
            />
            <div className="text-xs font-bold uppercase tracking-wider text-gray-800">Medlem siden 2023</div>
            <div className="text-[11px] text-gray-500 mt-0.5">Værkstedet med den høje standard</div>
          </div>
        </div>
      </div>
    </section>
  )
}
